import { setIn, getIn } from '@gogame/form';

export const RESET_STATE = 'RESET_STATE';
export const ADD_NODE = 'ADD_NODE';
export const REMOVE_NODE = 'REMOVE_NODE';
export const UPDATE = 'UPDATE';
export const SET_FIELD_VALUE = 'SET_FIELD_VALUE';
export const RESET_BUDGET = 'RESET_BUDGET';
export const APPLY_METRIC_BELLOW = 'APPLY_METRIC_BELLOW';

const resetBudgetNodes = ({ nodes, ...node }, activityType) => ({
  ...node,
  nodes: nodes.map((n) => ({
    ...n,
    activityTypes: {
      ...n.activityTypes,
      ...(n.activityTypes[activityType]
        ? {
            [activityType]: {
              ...n.activityTypes[activityType],
              budget: 0,
            },
          }
        : null),
    },
  })),
});

const setMetricsDepth = (
  { activityTypes, nodes, ...node },
  activityType,
  metric,
  value
) => ({
  ...node,
  nodes: nodes.map((node) =>
    setMetricsDepth(node, activityType, metric, value)
  ),
  activityTypes: {
    ...activityTypes,
    ...(activityTypes[activityType]
      ? {
          [activityType]: {
            ...activityTypes[activityType],
            metrics: {
              ...activityTypes[activityType].metrics,
              [metric]: value,
            },
          },
        }
      : null),
  },
});

const updateNodes = (state, updateNodes) => {
  const parse = ({ nodes, ...node }) => {
    const foundNode = updateNodes.find(({ id }) => id === node.id);

    if (foundNode) {
      return {
        ...node,
        activityTypes: foundNode.activityTypes,
        nodes: nodes.map(parse),
      };
    }

    return {
      ...node,
      nodes: nodes.map(parse),
    };
  };
  return parse(state);
};

const findParent = (node, parentId) => {
  if (parentId === node.id) {
    return node;
  }

  for (let i = 0; i < node.nodes.length; i++) {
    const foundNode = findParent(node.nodes[i], parentId);
    if (foundNode) {
      return foundNode;
    }
  }

  return null;
};

const createNodes = (state, parentId, createdNodes) => {
  let parent = findParent(state, parentId);

  const newParent = {
    ...parent,
    nodes: [...parent.nodes, ...createdNodes],
  };

  const updateState = (node) => {
    if (node.id === parentId) {
      return newParent;
    }
    return {
      ...node,
      nodes: node.nodes.map(updateState),
    };
  };

  return updateState(state);
};

const filterDepth = ({ nodes, ...node }, callback) => {
  if (callback(node)) {
    return {
      ...node,
      nodes: nodes.map((n) => filterDepth(n, callback)).filter((i) => i),
    };
  }
};

export const reducer = (state, action) => {
  switch (action.type) {
    case UPDATE: {
      const { nodes = [] } = action.payload;
      return updateNodes(state, nodes);
    }

    case SET_FIELD_VALUE: {
      const { name, value } = action.payload;
      return setIn(state, name, value);
    }

    case REMOVE_NODE: {
      return filterDepth(state, ({ id }) => id !== action.payload);
    }

    case RESET_BUDGET: {
      const { levelPath, activityType } = action.payload;
      const levelValue = levelPath ? getIn(state, levelPath) : state;
      const changedStatePart = resetBudgetNodes(levelValue, activityType);

      return levelPath
        ? setIn(state, levelPath, changedStatePart)
        : changedStatePart;
    }

    case APPLY_METRIC_BELLOW: {
      const { levelPath, activityType, metric, value } = action.payload;
      const levelValue = getIn(state, levelPath);
      const changedStatePart = setMetricsDepth(
        levelValue,
        activityType,
        metric,
        value
      );
      return setIn(state, levelPath, changedStatePart);
    }

    case ADD_NODE: {
      const { parentId, nodes } = action.payload;
      return createNodes(state, parentId, nodes);
    }

    case RESET_STATE: {
      return action.payload;
    }

    default:
      return state;
  }
};

export default reducer;
